<template>
  <v-app>
    <v-app-bar clipped-left app dark dense color="#283593">
      <ClientNameAppbar />

      <v-btn icon right color="#F57C00" @click="logoff">
        <v-icon>mdi-power-standby</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main>
      <div class="center-of-screen app">
        <div class="main-content">
          <v-tooltip bottom v-if="permissaoPabx" allow-overflow>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-4 mb-8"
                elevation="4"
                fab
                width="150"
                height="150"
                color="lightenBlue"
                @click="goToPabx"
                v-bind="attrs"
                v-on="on"
                href="/pabx"
                target="_blank"
              >
                <v-icon size="120" color="#000" class="icon-button">mdi-cog</v-icon>
              </v-btn>
            </template>
            <span>PABX</span>
          </v-tooltip>

          <v-tooltip bottom v-if="permissaoRelatorioPabx">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-4 mb-8"
                elevation="4"
                fab
                width="150"
                height="150"
                color="lightenBlue"
                @click="goToRelatoriosPabx"
                v-bind="attrs"
                v-on="on"
                href="/relatorios-pabx"
                target="_blank"
              >
                <v-icon size="120" color="#000" class="icon-button">mdi-clipboard-check-outline</v-icon>
              </v-btn>
            </template>
            <span>Relatórios PABX</span>
          </v-tooltip>

          <v-tooltip bottom v-if="permissaoMonitorRamais">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-4 mb-8"
                elevation="4"
                fab
                width="150"
                height="150"
                color="lightenBlue"
                @click="goToMonitorOnly"
                v-bind="attrs"
                v-on="on"
                href="/monitor-ramais"
                target="_blank"
              >
                <v-icon size="120" color="#000" class="icon-button">mdi-monitor</v-icon>
              </v-btn>
            </template>
            <span>Monitor de Ramais</span>
          </v-tooltip>

          <v-tooltip bottom v-if="permissaoCallCenter">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-4 mb-8"
                elevation="4"
                fab
                width="150"
                height="150"
                color="lightenBlue"
                @click="goToCallCenter"
                v-bind="attrs"
                v-on="on"
                href="/central-de-atendimento"
                target="_blank"
              >
                <v-icon size="120" color="#000" class="mr-1">mdi-phone-message</v-icon>
              </v-btn>
            </template>
            <span>Central de Atendimento</span>
          </v-tooltip>

          <v-tooltip bottom v-if="permissaoPesquisaSatisfacao">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-4 mb-8"
                elevation="4"
                fab
                width="150"
                height="150"
                color="lightenBlue"
                @click="goToSatisfactionResearch"
                v-bind="attrs"
                v-on="on"
                href="/central-de-atendimento"
                target="_blank"
              >
                <v-icon size="120" color="#000" class="icon-button mb-3">mdi-text-box-search</v-icon>
              </v-btn>
            </template>
            <span>Pesquisa de Satisfação</span>
          </v-tooltip>

          <v-tooltip bottom v-if="permissaoUsuarios">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-4 mb-8"
                elevation="4"
                fab
                width="150"
                height="150"
                color="lightenBlue"
                @click="goToAccessControl"
                v-bind="attrs"
                v-on="on"
                href="/controle-de-acesso"
                target="_blank"
              >
                <v-icon size="120" color="#000" class="icon-button mr-3 mb-6">mdi-account-lock</v-icon>
              </v-btn>
            </template>
            <span>Controle de Acesso</span>
          </v-tooltip>
        </div>
      </div>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Footer from '@/componentes/Footer'
import ClientNameAppbar from '@/componentes/ClientNameAppbar'
import { appBarMixins } from '@/mixins/appBarMixins'
import { logoutMethod } from '@/utils/commomMethods/logoutMethod'

export default {
  name: 'SelectModule',

  components: { ClientNameAppbar, Footer },

  mixins: [appBarMixins],

  methods: {
    ...logoutMethod,
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}

.center-of-screen {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-content {
  max-width: 95%;
  padding-top: 16px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.icon-button {
  margin-right: 1px;
}
</style>
